import { render, staticRenderFns } from "./marketingActivityAddAndEdit.vue?vue&type=template&id=59572b1e&scoped=true"
import script from "./marketingActivityAddAndEdit.vue?vue&type=script&lang=js"
export * from "./marketingActivityAddAndEdit.vue?vue&type=script&lang=js"
import style0 from "./marketingActivityAddAndEdit.vue?vue&type=style&index=0&id=59572b1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59572b1e",
  null
  
)

export default component.exports